import { useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './FJPreviewModal.module.less';
import FJModalClose from '../FJModalClose/FJModalClose';
import FJLocalStore from '../../../store/FJLocalStore';
import DownloadIcon from '../../../assets/svg/download.svg?react';
import DownloadBlackIcon from '../../../assets/svg/download_black.svg?react';
import ApplyIcon from '../../../assets/svg/apply.svg?react';
import EditIcon from '../../../assets/svg/edit.svg?react';
import AddToMediaIcon from '../../../assets/svg/add-to-media.svg?react';
import CopyIcon from '../../../assets/svg/copy.svg?react';
import EditSfxIcon from '../../../assets/svg/edit_sfx.svg?react';
import FJConstant from '../../../constants/FJConstant';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';
import FJMessageStore from '../../../store/FJMessageStore';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import FJAppConstant from '../../../constants/FJAppConstant';
import FJImageItemPreview from '../../../common/components/FJImageItemPreview/FJImageItemPreview';
import FJVideoContent from '../../../common/components/FJVideoPlayer/FJVideoContent.jsx';
import FJImageItemIconBox from '../../../common/components/FJImageItemPreview/FJImageItemIconBox.jsx';
import PreviewGradientArrow from '../../../assets/svg/preview-gradient-arrow.svg?react';
import FJImage from '../../../common/components/FJImage/FJImage.jsx';
import FJAudioPreview from './FJAudioPreview.jsx';
import Download from '../../../lib/download.js';
import FJAudioTag from '../../../common/components/FJAudioTag/FJAudioTag.jsx';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip.jsx';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton.jsx';
import { IMAGE_UPLOAD_MODES } from '../../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJHorizontalScrollArrow from '../../../common/components/FJTab/FJHorizontalScrollArrow.jsx';

const FJPreviewModal = props => {
    const {
        appType,
        data = {},
        onClose,
        onDownload,
        onDelete,
        onEdit,
        addAsScene,
        onEditSfx,
        addToMedia,
        shareToSociety,
        isActiveNext,
        isActivePrevious,
        switchPreview,
        addAsEditPageModalBtuStatus,
        isApplyButton,
        onApply,
        active,
        isAudioGenerator,
        isVideoGeneration,
        isVideoRemoveBg,
        isVideoDub,
        garment,
        videoEffectStyleItem,
    } = props;
    const {
        imgUrl,
        originalUrl,
        type,
        textToImagePrompt,
        videoUrl,
        prompt,
        width,
        height,
        generationType,
        ratio,
        job_type,
        singleImage, // 视频生成 单张图片
        startImage, // 视频生成 开始图片
        endImage, // 视频生成 结束图片
        multiImage, // 视频生成 多张图片
        sfxSupported, // 视频生成 是否支持sfx
        currentImageMode, // 视频生成 当前图片模式
        workType,
    } = data;
    const { audioUrl, coverUrl, lyrics, audioName, audioTagType } = data;

    const videoContentRef = useRef(null);
    const audioRef = useRef(null);
    const [stateIsDownloadLoading, setStateIsDownloadLoading] = useState(false);

    const infoList = useMemo(() => {
        return FJUtil.parseModalInfoList(data, appType, { videoEffectStyleItem });
    }, [data, appType, videoEffectStyleItem]);

    const _copyTextToImagePrompt = () => {
        if (isVideoGeneration || isVideoDub) {
            FJUtil.copyText(prompt);
        } else if (isAudioGenerator) {
            FJUtil.copyText(prompt || lyrics);
        } else if (appType === FJAppConstant.OBJECT_ERASER || appType === FJAppConstant.AI_PHOTO_EDITOR) {
            FJUtil.copyText(prompt);
        } else {
            FJUtil.copyText(textToImagePrompt);
        }
        FJMessageStore.addMessage(FJLocalStore._('copied-successfully'));
    };

    const _downloadImage = async () => {
        try {
            const blob = await FJUtil.downloadImageCacheAvoidance(coverUrl);
            const fileName = FJUtil.getUseFileName(audioName, '.png');
            Download(blob, fileName, 'image/png');
        } catch (e) {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-download-please-try-again'), 'error');
        }
    };

    const _onDownload = () => {
        setStateIsDownloadLoading(true);
        onDownload(() => {
            setStateIsDownloadLoading(false);
        });
    };

    const _onRefresh = () => {
        audioRef.current.reloadCover();
    };

    const isShowComparison =
        appType !== FJAppConstant.TEXT_TO_IMAGE &&
        appType !== FJAppConstant.IMAGE_EXTENDER &&
        appType !== FJAppConstant.IMAGE_ENHANCER &&
        appType !== FJAppConstant.PHOTO_RESTORATION &&
        appType !== FJAppConstant.PHOTO_COLORIZE &&
        appType !== FJAppConstant.VIDEO_REMOVE_BG &&
        !data.inputImages?.length;

    const isShowSlideCompare =
        appType === FJAppConstant.IMAGE_ENHANCER ||
        appType === FJAppConstant.PHOTO_RESTORATION ||
        appType === FJAppConstant.PHOTO_COLORIZE;

    const isShowShareIcon = appType !== FJAppConstant.WATERMARK_REMOVER;

    const isShowDeleteIcon = type === FJConstant.HISTORY;

    const isShowEditIcon =
        (appType === FJAppConstant.PHOTO_REMOVE_BG || appType === FJAppConstant.VIDEO_REMOVE_BG) && !workType;

    const isShowAiSfxButton = appType === FJAppConstant.AI_VIDEO_GENERATOR && generationType !== 'ev';

    const _renderGarment = () => {
        return (
            <div className={styles.garment_box}>
                <div className={styles.garment_title}>{FJLocalStore._('clothes')}</div>
                <FJImage
                    imgSrc={garment}
                    boxClassName={styles.garment_img_box}
                    imgClassName={styles.garment_img}
                    isShowLoading={true}
                />
                <div className={styles.garment_line} />
            </div>
        );
    };

    const _renderButton = () => {
        if (window.isEditPage) {
            return (
                <>
                    <FJButton
                        className={classNames(styles.btn, styles.margin_bottom_10)}
                        textClassName={styles.btn_text}
                        icon={isApplyButton ? <ApplyIcon /> : <AddToMediaIcon />}
                        text={FJLocalStore._(isApplyButton ? 'apply' : 'add-to-media')}
                        onClick={isApplyButton ? onApply : addToMedia}
                        type={FJButtonType.GRADIENT}
                        strokeColor={'#FFF'}
                    />
                    <FJButton
                        className={classNames(styles.btn, styles.margin_bottom_37)}
                        textClassName={styles.btn_text}
                        icon={<DownloadBlackIcon />}
                        text={FJLocalStore._('download')}
                        onClick={_onDownload}
                        isLoading={stateIsDownloadLoading}
                    />
                </>
            );
        } else {
            return (
                <>
                    <FJButton
                        className={classNames(styles.btn, styles.margin_bottom_10)}
                        textClassName={styles.btn_text}
                        icon={<DownloadIcon />}
                        text={FJLocalStore._('download')}
                        onClick={_onDownload}
                        type={FJButtonType.GRADIENT}
                        isLoading={stateIsDownloadLoading}
                        strokeColor={'#FFF'}
                    />

                    {!isShowAiSfxButton ? (
                        <FJButton
                            className={classNames(styles.btn, styles.margin_bottom_30)}
                            textClassName={styles.btn_text}
                            icon={<EditIcon />}
                            text={FJLocalStore._('use-in-a-design')}
                            onClick={addAsScene}
                            type={FJButtonType.DEFAULT}
                            isLoading={addAsEditPageModalBtuStatus === FJConstant.LOADING}
                        />
                    ) : (
                        <div className={classNames(styles.ai_sfx_btn_box, styles.margin_bottom_30)}>
                            <FJButton
                                className={classNames(styles.btn)}
                                textClassName={styles.btn_text}
                                icon={<EditIcon />}
                                text={FJLocalStore._('edit')}
                                onClick={addAsScene}
                            />

                            {sfxSupported && (
                                <FJButton
                                    className={classNames(styles.btn)}
                                    textClassName={styles.btn_text}
                                    icon={<EditSfxIcon />}
                                    text={FJLocalStore._('ai-sfx-1')}
                                    onClick={onEditSfx}
                                />
                            )}
                        </div>
                    )}
                </>
            );
        }
    };

    const renderLeftContent = () => {
        if (isVideoRemoveBg || isVideoDub) {
            return (
                <div className={styles.video_box} ref={videoContentRef}>
                    <FJVideoContent
                        url={videoUrl}
                        isLoop={true}
                        ratio={width / height}
                        style={{ position: 'absolute' }}
                        isShowTransparentBG={isVideoRemoveBg}
                    />
                    <FJImageItemIconBox
                        onDelete={onDelete}
                        shareToSociety={shareToSociety}
                        isShowDeleteIcon={true}
                        isShowComparison={false}
                        imageLoadingError={false}
                        disabledComparison={true}
                        isComparisonActive={false}
                        isShowEditIcon={isVideoRemoveBg ? isShowEditIcon : false}
                        onEdit={isVideoRemoveBg ? onEdit : undefined}
                    />
                </div>
            );
        } else if (isVideoGeneration) {
            return (
                <div className={styles.video_box} ref={videoContentRef}>
                    <FJVideoContent
                        url={videoUrl}
                        isLoop={true}
                        ratio={ratio}
                        style={{ position: 'absolute' }}
                        isShowFullScreen={true}
                        ignoreViewSize={generationType === 'ev'}
                    />
                    <FJImageItemIconBox
                        onDelete={onDelete}
                        shareToSociety={shareToSociety}
                        isShowDeleteIcon={true}
                        isShowComparison={false}
                        imageLoadingError={false}
                        disabledComparison={true}
                        isComparisonActive={false}
                    />
                </div>
            );
        } else if (isAudioGenerator) {
            return (
                <div className={styles.video_box}>
                    <FJAudioPreview audioUrl={audioUrl} coverUrl={coverUrl} active={active} ref={audioRef} />
                    <FJImageItemIconBox
                        onDelete={onDelete}
                        shareToSociety={shareToSociety}
                        isShowDeleteIcon={true}
                        isShowComparison={false}
                        imageLoadingError={false}
                        disabledComparison={true}
                        isComparisonActive={false}
                    />
                </div>
            );
        } else {
            return (
                <FJImageItemPreview
                    imgUrl={imgUrl}
                    originalUrl={originalUrl}
                    isShowDeleteIcon={isShowDeleteIcon}
                    isShowComparison={isShowComparison}
                    isShowSlideCompare={isShowSlideCompare}
                    onDelete={onDelete}
                    shareToSociety={shareToSociety}
                    isShowEditIcon={isShowEditIcon}
                    isShowShareIcon={isShowShareIcon}
                    onEdit={onEdit}
                />
            );
        }
    };

    const _onClose = () => {
        onClose();
        if (audioRef && audioRef.current) {
            audioRef.current.reset();
        }
    };

    // AI 音乐右侧内容 根据job_type 分别渲染
    const _renderAudioRightContent = () => {
        switch (job_type) {
            case 17:
                return lyrics && audioTagType === FJConstant.AUDIO_TAG_TYPE_MUSIC ? (
                    <div
                        className={classNames(styles.info_item_prompt, styles.audio_lyric)}
                        style={{ flexGrow: '1', marginTop: '14px' }}
                    >
                        <div className={styles.info_title_box}>
                            <span className={styles.info_title}>{FJLocalStore._('your-lyrics')}</span>
                            <div
                                className={styles.info_title_icon}
                                onClick={() => {
                                    FJUtil.copyText(lyrics);
                                    FJMessageStore.addMessage(FJLocalStore._('copied-successfully'));
                                }}
                            >
                                <CopyIcon />
                            </div>
                        </div>
                        <FJVerticalScroller
                            className={classNames(styles.info_lyric)}
                            style={{ maxHeight: 'calc(100% - 38px)' }}
                        >
                            {lyrics}
                        </FJVerticalScroller>
                    </div>
                ) : (
                    // 伴奏时 填充剩余空间
                    <div style={{ marginTop: '14px', flexGrow: '1' }}></div>
                );
            case 21:
                return (
                    <div style={{ marginTop: '14px', flexGrow: '1' }}>
                        {prompt && (
                            <div className={classNames(styles.info_item_prompt, styles.audio_prompt)}>
                                <div className={styles.info_title_box}>
                                    <span className={styles.info_title}>{FJLocalStore._('your-prompt')}</span>
                                    <div
                                        className={styles.info_title_icon}
                                        onClick={() => {
                                            FJUtil.copyText(prompt);
                                            FJMessageStore.addMessage(FJLocalStore._('copied-successfully'));
                                        }}
                                    >
                                        <CopyIcon />
                                    </div>
                                </div>
                                <FJVerticalScroller
                                    className={classNames(styles.info_lyric)}
                                    style={{ maxHeight: '48px' }}
                                >
                                    {prompt}
                                </FJVerticalScroller>
                            </div>
                        )}
                    </div>
                );
            case 29:
                return (
                    <FJVerticalScroller
                        className={classNames(styles.audio_prompt_and_lyric)}
                        style={{ marginTop: '14px' }}
                    >
                        {prompt && (
                            <div className={classNames(styles.info_item_prompt, styles.audio_prompt)}>
                                <div className={styles.info_title_box}>
                                    <span className={styles.info_title}>{FJLocalStore._('your-prompt')}</span>
                                    <div
                                        className={styles.info_title_icon}
                                        onClick={() => {
                                            FJUtil.copyText(prompt);
                                            FJMessageStore.addMessage(FJLocalStore._('copied-successfully'));
                                        }}
                                    >
                                        <CopyIcon />
                                    </div>
                                </div>
                                <FJVerticalScroller
                                    className={classNames(styles.info_lyric)}
                                    style={{ maxHeight: '48px' }}
                                >
                                    {prompt}
                                </FJVerticalScroller>
                            </div>
                        )}
                        {lyrics && prompt && (
                            <div className={styles.line} style={{ flex: 'none', margin: '14px 0' }}></div>
                        )}
                        {lyrics && audioTagType === FJConstant.AUDIO_TAG_TYPE_MUSIC && (
                            <div className={classNames(styles.info_item_prompt, styles.audio_lyric)}>
                                <div className={styles.info_title_box}>
                                    <span className={styles.info_title}>{FJLocalStore._('your-lyrics')}</span>
                                    <div
                                        className={styles.info_title_icon}
                                        onClick={() => {
                                            FJUtil.copyText(lyrics);
                                            FJMessageStore.addMessage(FJLocalStore._('copied-successfully'));
                                        }}
                                    >
                                        <CopyIcon />
                                    </div>
                                </div>
                                <FJVerticalScroller
                                    className={classNames(styles.info_lyric)}
                                    style={{ maxHeight: '144px' }}
                                >
                                    {lyrics}
                                </FJVerticalScroller>
                            </div>
                        )}
                    </FJVerticalScroller>
                );
            default:
                return null;
        }
    };

    return (
        <div className={styles.box}>
            <FJModalClose onClick={_onClose} className={styles.close} />
            <div
                className={classNames(
                    styles.catalog_icon_box,
                    styles.catalog_left,
                    !isActivePrevious ? styles.disable : '',
                )}
                onClick={() => {
                    switchPreview(false);
                }}
            >
                <PreviewGradientArrow />
            </div>
            <div
                className={classNames(
                    styles.catalog_icon_box,
                    styles.catalog_right,
                    !isActiveNext ? styles.disable : '',
                )}
                onClick={() => {
                    switchPreview(true);
                }}
            >
                <PreviewGradientArrow />
            </div>

            <div className={styles.content}>
                {renderLeftContent()}

                <FJVerticalScroller className={classNames(styles.right, isAudioGenerator && styles.right_flex)}>
                    {_renderButton()}

                    {/* 智能编辑预览 */}
                    {appType === FJAppConstant.AI_PHOTO_EDITOR && data.inputImages?.length > 0 && (
                        <div className={styles.images_box}>
                            <div className={styles.images_title}>
                                {FJLocalStore._(data.inputImages?.length > 1 ? 'images' : 'image')}
                            </div>
                            <FJHorizontalScrollArrow
                                leftButtonStyle={{ left: -8 }}
                                rightButtonStyle={{ right: -8 }}
                                updateList={data.inputImages}
                                className={classNames(styles.images_list_box)}
                            >
                                <div
                                    className={classNames(styles.images_list, {
                                        [styles.images_list_small]: data.inputImages?.length > 4,
                                    })}
                                >
                                    {data.inputImages?.map((imgSrc, index) => (
                                        <FJImage
                                            key={index}
                                            imgSrc={imgSrc}
                                            boxClassName={styles.images_img_box}
                                            imgClassName={styles.images_img}
                                            isShowLoading={true}
                                        />
                                    ))}
                                </div>
                            </FJHorizontalScrollArrow>
                            <div className={styles.garment_line} />
                        </div>
                    )}
                    {/*  文生图、图生图、对象擦除、视频配音显示prompt */}
                    {(textToImagePrompt ||
                        (prompt && isVideoDub) ||
                        (prompt && appType === FJAppConstant.OBJECT_ERASER) ||
                        (prompt && appType === FJAppConstant.AI_PHOTO_EDITOR)) && (
                        <>
                            <div className={styles.info_item_prompt}>
                                <div className={styles.info_title_box}>
                                    <span className={styles.info_title}>
                                        {isVideoDub ? FJLocalStore._('video-description') : FJLocalStore._('prompt')}
                                    </span>
                                    <div className={styles.info_title_icon} onClick={_copyTextToImagePrompt}>
                                        <CopyIcon />
                                    </div>
                                </div>
                                <FJVerticalScroller className={classNames(styles.info_content_prompt)}>
                                    {textToImagePrompt || prompt}
                                </FJVerticalScroller>
                            </div>
                            {/* 图片编辑的多图 */}
                            {data.referenceImages?.length > 0 && (
                                <div className={styles.images_box}>
                                    <div className={styles.images_title}>
                                        {FJLocalStore._(data.referenceImages?.length > 1 ? 'images' : 'image')}
                                    </div>
                                    <FJHorizontalScrollArrow
                                        leftButtonStyle={{ left: -8 }}
                                        rightButtonStyle={{ right: -8 }}
                                        updateList={data.referenceImages}
                                        className={classNames(styles.images_list_box)}
                                    >
                                        <div className={styles.images_list}>
                                            {data.referenceImages?.map((imgSrc, index) => (
                                                <FJImage
                                                    key={index}
                                                    imgSrc={imgSrc}
                                                    boxClassName={styles.images_img_box}
                                                    imgClassName={styles.images_img}
                                                    isShowLoading={true}
                                                />
                                            ))}
                                        </div>
                                        <div className={styles.garment_line} />
                                    </FJHorizontalScrollArrow>
                                </div>
                            )}
                            <div className={styles.line}></div>
                        </>
                    )}

                    {/* 视频生成 */}
                    {isVideoGeneration && (
                        <>
                            {generationType === 'iv' && (
                                <div className={styles.info_item_prompt}>
                                    {/* 根据 currentImageMode 决定显示的UI */}
                                    {currentImageMode === IMAGE_UPLOAD_MODES.START_END ? (
                                        // 首尾帧模式：显示 Start 和 End
                                        <div className={styles.start_end_container}>
                                            {startImage && (
                                                <div className={styles.start_end_item}>
                                                    <div className={styles.info_title_box}>
                                                        <span className={styles.info_title}>
                                                            {FJLocalStore._('start-frame')}
                                                        </span>
                                                    </div>
                                                    <div className={styles.video_imgs}>
                                                        <FJImage
                                                            imgSrc={startImage}
                                                            boxClassName={styles.video_img_box}
                                                            imgClassName={styles.video_img}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {endImage && (
                                                <div className={styles.start_end_item}>
                                                    <div className={styles.info_title_box}>
                                                        <span className={styles.info_title}>
                                                            {FJLocalStore._('end-frame')}
                                                        </span>
                                                    </div>
                                                    <div className={styles.video_imgs}>
                                                        <FJImage
                                                            imgSrc={endImage}
                                                            boxClassName={styles.video_img_box}
                                                            imgClassName={styles.video_img}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        // 单图或多图模式
                                        <>
                                            <div className={styles.info_title_box}>
                                                <span className={styles.info_title}>
                                                    {currentImageMode === IMAGE_UPLOAD_MODES.MULTI
                                                        ? FJLocalStore._('images')
                                                        : FJLocalStore._('image')}
                                                </span>
                                            </div>
                                            <div className={styles.video_imgs}>
                                                {/* 单图模式 */}
                                                {singleImage && (
                                                    <FJImage
                                                        imgSrc={singleImage}
                                                        boxClassName={styles.video_img_box}
                                                        imgClassName={styles.video_img}
                                                    />
                                                )}
                                                {/* 首尾帧模式 但是只有首帧 */}
                                                {startImage && (
                                                    <FJImage
                                                        imgSrc={startImage}
                                                        boxClassName={styles.video_img_box}
                                                        imgClassName={styles.video_img}
                                                    />
                                                )}
                                                {/* 多图模式 */}
                                                {multiImage &&
                                                    multiImage.length > 0 &&
                                                    multiImage.map(
                                                        (url, index) =>
                                                            url && (
                                                                <FJImage
                                                                    key={index}
                                                                    imgSrc={url}
                                                                    boxClassName={styles.video_img_box}
                                                                    imgClassName={styles.video_img}
                                                                />
                                                            ),
                                                    )}
                                                {/* 兼容旧版：当没有新图片数据时，使用 originalUrl */}
                                                {!singleImage && !startImage && !multiImage && originalUrl && (
                                                    <FJImage
                                                        imgSrc={originalUrl}
                                                        boxClassName={styles.video_img_box}
                                                        imgClassName={styles.video_img}
                                                    />
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                            {generationType === 'ev' && (
                                <div className={styles.info_item_prompt}>
                                    <div className={styles.info_title_box}>
                                        <span className={styles.info_title}>{FJLocalStore._('image')}</span>
                                    </div>
                                    <div className={styles.effect_imgs}>
                                        {data.effectInfo.effectOriginalUrlList.map((url, index) => (
                                            <FJImage
                                                key={index}
                                                imgSrc={url}
                                                boxClassName={
                                                    data.effectInfo.effectOriginalUrlList.length > 1
                                                        ? styles.img_box_two
                                                        : styles.img_box
                                                }
                                                imgClassName={
                                                    data.effectInfo.effectOriginalUrlList.length > 1
                                                        ? styles.img_two
                                                        : styles.img
                                                }
                                            />
                                        ))}
                                    </div>
                                </div>
                            )}
                            {prompt && (
                                <div className={styles.info_item_prompt}>
                                    <div className={styles.info_title_box}>
                                        <span className={styles.info_title}>{FJLocalStore._('prompt')}</span>
                                        <div className={styles.info_title_icon} onClick={_copyTextToImagePrompt}>
                                            <CopyIcon />
                                        </div>
                                    </div>
                                    <FJVerticalScroller className={classNames(styles.info_content_prompt)}>
                                        {prompt}
                                    </FJVerticalScroller>
                                </div>
                            )}
                            <div className={styles.line}></div>
                        </>
                    )}

                    {/* 音频生成 */}
                    {isAudioGenerator && (
                        <div className={styles.info_item_prompt}>
                            <div className={styles.info_title_box}>
                                <span className={styles.info_title}>{FJLocalStore._('music-info')}</span>
                                <FJToolTip title={FJLocalStore._('download-cover')}>
                                    <div className={styles.info_title_icon} onClick={_downloadImage}>
                                        <DownloadBlackIcon />
                                    </div>
                                </FJToolTip>
                            </div>
                            <div className={styles.music_info}>
                                <FJImage
                                    imgSrc={coverUrl}
                                    boxClassName={styles.img_box}
                                    imgClassName={styles.img}
                                    onRefresh={_onRefresh}
                                    isShowLoading={true}
                                />
                                <div className={styles.info_right}>
                                    <div className={styles.name}>{audioName}</div>
                                    <FJAudioTag type={audioTagType} className={styles.tag} />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* 服装素材 */}
                    {garment && _renderGarment()}

                    {/* 音频生成 */}
                    {isAudioGenerator && _renderAudioRightContent()}

                    {isAudioGenerator && <div className={styles.line} style={{ flex: 'none', margin: '14px 0' }}></div>}

                    {/* 其他信息 */}

                    {infoList.map((item, index) => (
                        <div className={styles.info_item} key={index}>
                            <span className={styles.info_title}>{FJLocalStore._(item.title)}</span>
                            <span className={styles.info_content}>{item.content}</span>
                        </div>
                    ))}
                </FJVerticalScroller>
            </div>
        </div>
    );
};
FJPreviewModal.propTypes = {
    appType: PropTypes.string,
    data: PropTypes.object,
    onClose: PropTypes.func,
    onDownload: PropTypes.func,
    onDelete: PropTypes.func,
    addAsScene: PropTypes.func,
    shareToSociety: PropTypes.func,
    isActiveNext: PropTypes.bool,
    isActivePrevious: PropTypes.bool,
    switchPreview: PropTypes.func,
    addAsEditPageModalBtuStatus: PropTypes.string,
    onEdit: PropTypes.func,
    addToMedia: PropTypes.func,
    onApply: PropTypes.func,
    active: PropTypes.bool,
    isApplyButton: PropTypes.bool,
    isAudioGenerator: PropTypes.bool,
    isVideoGeneration: PropTypes.bool,
    isVideoRemoveBg: PropTypes.bool,
    garment: PropTypes.bool,
    isVideoDub: PropTypes.bool,
    onEditSfx: PropTypes.func,
    videoEffectStyleItem: PropTypes.object,
};
export default FJPreviewModal;
